<template>
  <div class="dashboard-container">
    <b-container>
      <div class="search-container">
        <div class="payment-view">
          <div class="payment-header-wrapper">
            <span>Trade Search</span>
          </div>
          <div>
            <b-input-group size="sm" class="mb-2">
              <!-- <b-input-group-prepend is-text>
                <span>Search</span>
              </b-input-group-prepend> -->
              <b-form-input
                v-model="discord_id"
                type="search"
                @keyup="enter_listener"
                placeholder="Enter User Discord ID"
              ></b-form-input>
            </b-input-group>
            <b-button @click="search_trade">Search</b-button>
          </div>
        </div>
        <div v-show="dataLoaded">
          <b-spinner label="Spinning"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </div>

      <div class="trade-container" v-show="trades.length > 0">
        <div class="payment-view">
          <div class="payment-header-wrapper">
            <span>Search Result</span>
          </div>
          <div>
            <div>
              <b-table
                striped
                hover
                dark
                sticky-header="640px"
                responsive
                :items="trades"
                :fields="fields"
              ></b-table>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import db from "../../database/index";
const trade_collection = db.collection("TradeTracking");

// import TradeTracking from '@/components/TradeTracking';

export default {
  name: "TradeDetails",
  metaInfo: {
    title: "Market Moves - Trade Details",
    titleTemplate: "TradeDetails",
  },
  components: {
    // TradeTracking,
  },
  data() {
    return {
      id: this.$route.params.id,
      dataLoaded: false,
      discord_id: "",
      trades: [],
      fields: [
        {
          key: "date",
          // sortable: true,
        },
        {
          key: "details",
        },
        {
          key: "profit",
          sortable: true,
        },
      ],
      //   discord: {},
      //   user: {},
      //   email: '',
      //   dataLoaded: false,
      //   processor: '',
      //   hasSignedTOS: false,
      //   error: false
    };
  },
  async mounted() {
    // Check is user is authorized to use dashboard
    if (!this.$cookies.get("session_token")) this.$router.push({ path: "/" });

    this.discord_id = this.id;

    this.search_trade();

    // this.$refs["spinner"].
  },
  methods: {
    async search_trade() {
      // SHow Spinner
      this.dataLoaded = true;
      // Remove whitespace from search
      this.discord_id = this.discord_id.replace(/\s/g, "");
      console.log(this.discord_id);
      // Reset trade arrat
      this.trades = [];

      // Search if search term is valid
      if (this.discord_id > 0) {
        trade_collection
          .doc(this.discord_id)
          .get()
          .then((doc) => {
            // User Data Exists
            if (doc.exists) {
              let results = doc.data().results;

              results.forEach((ele) => {
                // Create object
                let trade_data = { profit: ele.profit };

                try {
                  trade_data["date"] = this.convertUnix(ele.date.toMillis());
                } catch (error) {
                  trade_data["date"] = this.convertUnix(ele.date * 1000);
                }

                try {
                  let details = ele.details;
                  trade_data[
                    "details"
                  ] = `${details.sid} ${details.callOrPuts} ${details.strike} ${details.exp}`;
                } catch (error) {
                  trade_data["details"] = "NA";
                }

                // Push into array
                this.trades.push(trade_data);
              });
            } else {
              console.log("No Data in Trade");
            }
          })
          .catch((err) => {
            console.log(err);
          });

        this.dataLoaded = false;
      }

      this.dataLoaded = false;
    },
    async enter_listener(e) {
      e.preventDefault();
      if (e.keyCode === 13) {
        this.search_trade();
      }
    },
    async open_discord_search() {
      this.discord_id = this.discord_id.replace(/\s/g, "");
      if (this.discord_id !== this.$route.params.id) {
        this.$router.push({ path: "/tradedetails/" + this.discord.id });
      }
    },
    convertUnix(ts) {
      let date = new Date(ts);
      const month = date.toLocaleString("en-US", { month: "long" });
      const day = date.toLocaleString("en-US", { day: "numeric" });
      const year = date.toLocaleString("en-US", { year: "numeric" });
      return month + " " + day + ", " + year;
    },
  },
};
</script>


<style scoped>
.trade-container {
  height: 240px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.search-container {
  height: 140px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.payment-header-wrapper {
  padding-top: 20px;
  font-weight: 800;
  font-size: 1.17em;
  text-transform: uppercase;
}

.cc-info-wrapper__1 {
  margin-top: 50px;
  margin-bottom: 35px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.cc-info-wrapper__2 {
  margin-top: 25px;
  margin-bottom: 35px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.cc-info-wrapper__3 {
  margin-top: 20px;
  margin-bottom: 25px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.prevent-btn-container {
  display: flex;
  justify-content: space-evenly;
  margin-top: 12px;
}

.cc-info-text__1 {
  margin-top: 15px;
}

.cancel-sub button {
  background-color: #eb675e;
  border: #eb675e;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
  height: 28px;
}

.cancel-sub button:hover {
  background-color: #e98f88;
  border-color: #e98f88;
}

.cancel-sub button:active {
  position: relative;
  top: 1px;
}

.cancel-sub button:focus {
  outline: 0;
}

.cancel-confirmation {
  padding-top: 30px;
}

.cancel-confirmation-title {
  padding-left: 25px;
  padding-right: 25px;
  font-size: 1.17em;
  font-weight: 800;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 10px;
}

.cancel-confirmation-text {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 25px;
  padding-right: 25px;
  font-size: 14px;
  text-align: justify;
}

.cancel-btns {
  display: flex;
  justify-content: space-evenly;
  margin-top: 15px;
}

.cancel-yes-btn {
  background: #eb675e;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-yes-btn:hover {
  background: #e98f88;
  border: #e98f88;
}

.cancel-no-btn {
  background: #7289da;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-no-btn:hover {
  background: #818fc0;
  border: #818fc0;
}

.resub button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.resub button:hover {
  background-color: #818fc0;
}

.resub button:focus {
  outline: 0;
}

.splash {
  margin: 0 auto;
  padding-top: 76px;
}

.splash-content {
  width: 88px;
  height: 88px;
  margin: 0 auto;
  border: 3px solid #7289da;
  border: 3px solid transparent;
  border-top-color: #7289da;
  border-bottom-color: #7289da;
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>